/**
 * Owns SDS book preview hook + panel so Inventory panel stays under the
 * file-size hygiene cap (MSDS-6).
 */
import { useCallback, useRef } from "react";
import { ManufacturingSdsBookPanel } from "./ManufacturingSdsBookPanel";
import { useManufacturingSdsBook } from "./useManufacturingSdsBook";

type Props = {
  open: boolean;
  enabled: boolean;
  plantId?: string;
  onClose: () => void;
};

export function ManufacturingSdsBookHost({ open, enabled, plantId, onClose }: Props) {
  const book = useManufacturingSdsBook({ open, enabled, plantId });
  const bookRef = useRef(book);
  bookRef.current = book;

  const handleClose = useCallback(() => {
    bookRef.current.reset();
    onClose();
  }, [onClose]);

  return (
    <ManufacturingSdsBookPanel
      open={open}
      loading={book.loading}
      exporting={book.exporting}
      error={book.error}
      plantName={book.plantName}
      organizationName={book.organizationName}
      includesDrafts={book.includesDrafts}
      candidates={book.candidates}
      onDownload={() => void bookRef.current.download()}
      onClose={handleClose}
    />
  );
}
